import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Background Generator";
const PROMPT_DOCUMENT_ID = "gpia9ow0dl1zrgowm0trn5p6";

const callGenerateBackgroundAuto = async (
	messageId: string,
	promptIndex: number,
	jwt: string,
	tool_document_id: string,
	batch_size: number,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				prompt_document_id: PROMPT_DOCUMENT_ID,
				prompt_index: promptIndex,
				input_images: [imageBase64],
				from_editor: true,
				jwt,
				tool_document_id,
				batch_size,
			};
			return fetchGenerateBackgroundAuto(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchGenerateBackgroundAuto(
	params: {
		prompt_document_id: string;
		prompt_index: number;
		input_images: string[];
		from_editor: boolean;
	},
	executionContext: any,
	messageId: string,
): Promise<string | string[] | false> {
	return fetchInferenceJob({
		params,
		executionContext,
		messageId,
		apiPath: "/infer/oplux",
		statusEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/status/${jobId}`,
		resultEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/result/${jobId}`,
		cancelEndpoint: (apiUrl, jobId) => ({
			url: `${apiUrl.replace("/infer/oplux", "")}/cancel/${jobId}`,
			method: "POST",
		}),
		extractResult: (data) => data.image_base64_list ?? [data.image_base64],
		useGatewayUrl: true,
	});
}

export function useListenGenerateBackgroundAutoMessage() {
	useListenFromRenderer([
		{
			key: "generateBackgroundAuto",
			onMessage: async (message) => {
				const success = await callGenerateBackgroundAuto(
					message.id,
					message.values.prompt_index,
					message.values.jwt,
					message.values.tool_document_id,
					message.values.batch_size,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
